import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-263ce81e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"position":"relative"},
  class: "quick-add-wrapper"
}
const _hoisted_2 = { class: "title-six" }
const _hoisted_3 = { class: "card-head" }
const _hoisted_4 = { class: "card-body is-flex-direction-column" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "table is-bordered is-striped is-narrow is-fullwidth is-hoverable" }
const _hoisted_9 = ["onClick", "onDblclick"]
const _hoisted_10 = { class: "card-foot" }
const _hoisted_11 = ["disabled"]

import SearchPopover from "@/components/common/popover/SearchPopover.vue"
import BulmaButtonIcon from "@/components/common/BulmaButtonIcon.vue"
import QuickAddModal from "@/components/common/QuickAddModal.vue"
import {ref, computed, watch} from 'vue'
import { getColorValue } from "@/store/modules/theme/getColorValue"
import contrastColors from "@/helpers/contrastColors"
import { useStore } from "vuex"
import { Button } from "@/buefy/dist/cjs"
import {SearchCallTypes} from "@/helpers/SearchCallType";
import QuickAddToCartPopover from "@/components/common/popover/QuickAddToCartPopover.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickAddButton',
  setup(__props) {

const store = useStore()
const showPopover = ref<boolean>(false)
const query = ref<string>('')

const suggestions = ref<Array<any>>([])
const selected = ref(null)
const quickAddClasses = computed(() => {
  const primaryColor = store.getters["theme/getTheme"].brand_primary
  let fontColor = contrastColors.colorText(primaryColor) === '#ffffff' ? 'has-text-white' : 'black-color'
  return 'is-primary' + ' ' + fontColor
})

watch(query, async (val, old) => {
  if(val === old) return
  // ensure search is cleared
  if( query.value === '') {
    suggestions.value = []
    return
  }
  selected.value = null
  suggestions.value = await store.dispatch('search/searchWithReturn', {
    callType: SearchCallTypes.QUICKADD,
    q: val,
    limit: 3,
    searchableType: ['Part']
  })
})

const select = (part: any) => {
  if (selected.value !== part) {
    selected.value = part
  } else {
    selected.value = null
  }
}

const clearAll = async (close: boolean) => {
  selected.value = null
  suggestions.value = []
  query.value = ''
  if (close) showPopover.value = false
}
const add = async (part: any) => {
  await clearAll(false)
  await store.dispatch('cart/addToCart',{
    part,
    qty: 1
  } )
}

const accessPopover = () => {
  if(showPopover.value) {
    clearAll(true)
  } else {
    showPopover.value = true
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BulmaButtonIcon, {
      class: "button",
      stylingClass: quickAddClasses.value,
      "icon-class": 'fas fa-cart-plus fa-lg',
      text: _ctx.$t('quickAdd'),
      onClick: accessPopover
    }, null, 8, ["stylingClass", "text"]),
    (showPopover.value)
      ? (_openBlock(), _createBlock(QuickAddToCartPopover, {
          key: 0,
          class: "popover",
          onClose: accessPopover
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('quickAddHelpText')), 1),
            _createElementVNode("header", _hoisted_3, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('quickAdd')), 1)
            ]),
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
                  type: "text",
                  autocomplete: "off",
                  autofocus: "",
                  placeholder: _ctx.$t('search') + '...',
                  "data-int": "quick-add-input",
                  class: "input quick-add-input is-primary"
                }, null, 8, _hoisted_6), [
                  [_vModelText, query.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value, (suggestion) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: suggestion.id,
                        class: _normalizeClass([{'is-selected': suggestion === selected.value}, "suggestion"]),
                        onClick: ($event: any) => (select(suggestion)),
                        onDblclick: _withModifiers(($event: any) => (add(suggestion)), ["stop"])
                      }, [
                        _createElementVNode("td", null, _toDisplayString(suggestion.identifier) + " - " + _toDisplayString(suggestion.name), 1)
                      ], 42, _hoisted_9))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("footer", _hoisted_10, [
              _createElementVNode("button", {
                disabled: !selected.value,
                class: "button is-primary add-button mr-1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (add(selected.value)))
              }, _toDisplayString(_ctx.$t('add')), 9, _hoisted_11),
              _createElementVNode("button", {
                class: "button cancel-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (clearAll(true)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})